export default "__VITE_ASSET__BfueAR5e__"